/* global axios */
// import ApiClient from './ApiClient';
import CacheEnabledApiClient from './CacheEnabledApiClient';

export class GiftCardAPI extends CacheEnabledApiClient {
  constructor() {
    super('gift_cards', { accountScoped: true });
  }

  getBrands() {
    return this.getOrCreatePersistentCacheWithoutDataManager({
      modelName: 'brands',
      fetchFunction: () => axios.get(`${this.url}/brands`),
      extractDataFromResponse: response => response.data,
    });
  }

  getCountries() {
    return this.getOrCreatePersistentCacheWithoutDataManager({
      modelName: 'countries',
      fetchFunction: () => axios.get(`${this.url}/countries`), // 定义网络数据获取逻辑
      extractDataFromResponse: response => response.data, // 数据提取逻辑
    });
  }

  getBankList(country_id) {
    return this.getOrCreatePersistentCacheWithoutDataManager({
      modelName: 'banks' + country_id,
      fetchFunction: () =>
        axios.post(`${this.url}/bank_list`, { country_id: country_id }),
      extractDataFromResponse: response => response.data,
    });
  }

  getRateList(country_id, conversation_id) {
    return axios.post(`${this.url}/rate_list`, { country_id: country_id, conversation_id: conversation_id });
  }

  getMemberDetails(contact_id, user_id = null) {
    return axios.post(`${this.url}/member_details`, {
      contact_id: contact_id,
      user_id: user_id,
    });
  }

  createOrder(orderData) {
    return axios.post(`${this.url}/create_order`, orderData);
  }

  orderList(queryData) {
    return axios.post(`${this.url}/order_list`, queryData);
  }

  getOrderDetails(id) {
    return axios.post(`${this.url}/order_details`, { id: id });
  }

  orderWithdraw(data) {
    return axios.post(`${this.url}/order_withdraw`, data);
  }

  userWithdraw(data) {
    return axios.post(`${this.url}/user_withdraw`, data);
  }

  notGiftCard(id) {
    return axios.post(`${this.url}/not_giftcard`, { id: id });
  }

  getUserList(conversation_id) {
    return axios.post(`${this.url}/user_list`, {
      conversation_id: conversation_id,
    });
  }
}

export default new GiftCardAPI();
